import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3857e4fa = () => interopDefault(import('../pages/address.vue' /* webpackChunkName: "pages/address" */))
const _35a8ed18 = () => interopDefault(import('../pages/banner_home.vue' /* webpackChunkName: "pages/banner_home" */))
const _508d2469 = () => interopDefault(import('../pages/cards.vue' /* webpackChunkName: "pages/cards" */))
const _e08117ec = () => interopDefault(import('../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _1cb34a30 = () => interopDefault(import('../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _27717229 = () => interopDefault(import('../pages/cmsPreview.vue' /* webpackChunkName: "pages/cmsPreview" */))
const _1aef7cda = () => interopDefault(import('../pages/coupons.vue' /* webpackChunkName: "pages/coupons" */))
const _344372e0 = () => interopDefault(import('../pages/dshop.vue' /* webpackChunkName: "pages/dshop" */))
const _761f3255 = () => interopDefault(import('../pages/notification.vue' /* webpackChunkName: "pages/notification" */))
const _1d8863af = () => interopDefault(import('../pages/notification_center.vue' /* webpackChunkName: "pages/notification_center" */))
const _cc8d7eb6 = () => interopDefault(import('../pages/offline_payment_checkout.vue' /* webpackChunkName: "pages/offline_payment_checkout" */))
const _2deb8b52 = () => interopDefault(import('../pages/order_details.vue' /* webpackChunkName: "pages/order_details" */))
const _8dd9924e = () => interopDefault(import('../pages/order_list.vue' /* webpackChunkName: "pages/order_list" */))
const _88a70040 = () => interopDefault(import('../pages/payment_result.vue' /* webpackChunkName: "pages/payment_result" */))
const _78571164 = () => interopDefault(import('../pages/pending_payment.vue' /* webpackChunkName: "pages/pending_payment" */))
const _6f7de986 = () => interopDefault(import('../pages/productDetails.vue' /* webpackChunkName: "pages/productDetails" */))
const _d5f21fa2 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _03a5f93e = () => interopDefault(import('../pages/receipt.vue' /* webpackChunkName: "pages/receipt" */))
const _3d268e12 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _58df4b71 = () => interopDefault(import('../pages/similar.vue' /* webpackChunkName: "pages/similar" */))
const _6966f084 = () => interopDefault(import('../pages/store_locator.vue' /* webpackChunkName: "pages/store_locator" */))
const _6dbe1f46 = () => interopDefault(import('../pages/auth/baseDialog.vue' /* webpackChunkName: "pages/auth/baseDialog" */))
const _bbf48760 = () => interopDefault(import('../pages/auth/link_error.vue' /* webpackChunkName: "pages/auth/link_error" */))
const _8e1272a8 = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/address",
    component: _3857e4fa,
    name: "address"
  }, {
    path: "/banner_home",
    component: _35a8ed18,
    name: "banner_home"
  }, {
    path: "/cards",
    component: _508d2469,
    name: "cards"
  }, {
    path: "/cart",
    component: _e08117ec,
    name: "cart"
  }, {
    path: "/checkout",
    component: _1cb34a30,
    name: "checkout"
  }, {
    path: "/cmsPreview",
    component: _27717229,
    name: "cmsPreview"
  }, {
    path: "/coupons",
    component: _1aef7cda,
    name: "coupons"
  }, {
    path: "/dshop",
    component: _344372e0,
    name: "dshop"
  }, {
    path: "/notification",
    component: _761f3255,
    name: "notification"
  }, {
    path: "/notification_center",
    component: _1d8863af,
    name: "notification_center"
  }, {
    path: "/offline_payment_checkout",
    component: _cc8d7eb6,
    name: "offline_payment_checkout"
  }, {
    path: "/order_details",
    component: _2deb8b52,
    name: "order_details"
  }, {
    path: "/order_list",
    component: _8dd9924e,
    name: "order_list"
  }, {
    path: "/payment_result",
    component: _88a70040,
    name: "payment_result"
  }, {
    path: "/pending_payment",
    component: _78571164,
    name: "pending_payment"
  }, {
    path: "/productDetails",
    component: _6f7de986,
    name: "productDetails"
  }, {
    path: "/profile",
    component: _d5f21fa2,
    name: "profile"
  }, {
    path: "/receipt",
    component: _03a5f93e,
    name: "receipt"
  }, {
    path: "/search",
    component: _3d268e12,
    name: "search"
  }, {
    path: "/similar",
    component: _58df4b71,
    name: "similar"
  }, {
    path: "/store_locator",
    component: _6966f084,
    name: "store_locator"
  }, {
    path: "/auth/baseDialog",
    component: _6dbe1f46,
    name: "auth-baseDialog"
  }, {
    path: "/auth/link_error",
    component: _bbf48760,
    name: "auth-link_error"
  }, {
    path: "/auth/login",
    component: _8e1272a8,
    name: "auth-login"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/d/:id.html",
    component: _344372e0,
    name: "dshop_id"
  }, {
    path: "/p/:title/s/:spuPart/i/:sku.html",
    component: _6f7de986,
    name: "pdp_title_i_sku1"
  }, {
    path: "/p/:title/i/:sku.html",
    component: _6f7de986,
    name: "pdp_title_i_sku"
  }, {
    path: "/zh-hant/address",
    component: _3857e4fa,
    name: "zh-hant_address"
  }, {
    path: "/en/address",
    component: _3857e4fa,
    name: "en_address"
  }, {
    path: "/zh-hant/banner_home",
    component: _35a8ed18,
    name: "zh-hant_banner_home"
  }, {
    path: "/en/banner_home",
    component: _35a8ed18,
    name: "en_banner_home"
  }, {
    path: "/zh-hant/cards",
    component: _508d2469,
    name: "zh-hant_cards"
  }, {
    path: "/en/cards",
    component: _508d2469,
    name: "en_cards"
  }, {
    path: "/zh-hant/cart",
    component: _e08117ec,
    name: "zh-hant_cart"
  }, {
    path: "/en/cart",
    component: _e08117ec,
    name: "en_cart"
  }, {
    path: "/zh-hant/checkout",
    component: _1cb34a30,
    name: "zh-hant_checkout"
  }, {
    path: "/en/checkout",
    component: _1cb34a30,
    name: "en_checkout"
  }, {
    path: "/zh-hant/cmsPreview",
    component: _27717229,
    name: "zh-hant_cmsPreview"
  }, {
    path: "/en/cmsPreview",
    component: _27717229,
    name: "en_cmsPreview"
  }, {
    path: "/zh-hant/coupons",
    component: _1aef7cda,
    name: "zh-hant_coupons"
  }, {
    path: "/en/coupons",
    component: _1aef7cda,
    name: "en_coupons"
  }, {
    path: "/zh-hant/dshop",
    component: _344372e0,
    name: "zh-hant_dshop"
  }, {
    path: "/en/dshop",
    component: _344372e0,
    name: "en_dshop"
  }, {
    path: "/zh-hant/notification",
    component: _761f3255,
    name: "zh-hant_notification"
  }, {
    path: "/en/notification",
    component: _761f3255,
    name: "en_notification"
  }, {
    path: "/zh-hant/notification_center",
    component: _1d8863af,
    name: "zh-hant_notification_center"
  }, {
    path: "/en/notification_center",
    component: _1d8863af,
    name: "en_notification_center"
  }, {
    path: "/zh-hant/offline_payment_checkout",
    component: _cc8d7eb6,
    name: "zh-hant_offline_payment_checkout"
  }, {
    path: "/en/offline_payment_checkout",
    component: _cc8d7eb6,
    name: "en_offline_payment_checkout"
  }, {
    path: "/zh-hant/order_details",
    component: _2deb8b52,
    name: "zh-hant_order_details"
  }, {
    path: "/en/order_details",
    component: _2deb8b52,
    name: "en_order_details"
  }, {
    path: "/zh-hant/order_list",
    component: _8dd9924e,
    name: "zh-hant_order_list"
  }, {
    path: "/en/order_list",
    component: _8dd9924e,
    name: "en_order_list"
  }, {
    path: "/zh-hant/payment_result",
    component: _88a70040,
    name: "zh-hant_payment_result"
  }, {
    path: "/en/payment_result",
    component: _88a70040,
    name: "en_payment_result"
  }, {
    path: "/zh-hant/pending_payment",
    component: _78571164,
    name: "zh-hant_pending_payment"
  }, {
    path: "/en/pending_payment",
    component: _78571164,
    name: "en_pending_payment"
  }, {
    path: "/zh-hant/productDetails",
    component: _6f7de986,
    name: "zh-hant_productDetails"
  }, {
    path: "/en/productDetails",
    component: _6f7de986,
    name: "en_productDetails"
  }, {
    path: "/zh-hant/profile",
    component: _d5f21fa2,
    name: "zh-hant_profile"
  }, {
    path: "/en/profile",
    component: _d5f21fa2,
    name: "en_profile"
  }, {
    path: "/zh-hant/receipt",
    component: _03a5f93e,
    name: "zh-hant_receipt"
  }, {
    path: "/en/receipt",
    component: _03a5f93e,
    name: "en_receipt"
  }, {
    path: "/zh-hant/search",
    component: _3d268e12,
    name: "zh-hant_search"
  }, {
    path: "/en/search",
    component: _3d268e12,
    name: "en_search"
  }, {
    path: "/zh-hant/similar",
    component: _58df4b71,
    name: "zh-hant_similar"
  }, {
    path: "/en/similar",
    component: _58df4b71,
    name: "en_similar"
  }, {
    path: "/zh-hant/store_locator",
    component: _6966f084,
    name: "zh-hant_store_locator"
  }, {
    path: "/en/store_locator",
    component: _6966f084,
    name: "en_store_locator"
  }, {
    path: "/zh-hant/auth/baseDialog",
    component: _6dbe1f46,
    name: "zh-hant_auth-baseDialog"
  }, {
    path: "/en/auth/baseDialog",
    component: _6dbe1f46,
    name: "en_auth-baseDialog"
  }, {
    path: "/zh-hant/auth/link_error",
    component: _bbf48760,
    name: "zh-hant_auth-link_error"
  }, {
    path: "/en/auth/link_error",
    component: _bbf48760,
    name: "en_auth-link_error"
  }, {
    path: "/zh-hant/auth/login",
    component: _8e1272a8,
    name: "zh-hant_auth-login"
  }, {
    path: "/en/auth/login",
    component: _8e1272a8,
    name: "en_auth-login"
  }, {
    path: "/zh-hant",
    component: _2dfb1658,
    name: "zh-hant"
  }, {
    path: "/en",
    component: _2dfb1658,
    name: "en"
  }, {
    path: "/zh-hant/d/:id.html",
    component: _344372e0,
    name: "zh-hant_dshop_id"
  }, {
    path: "/en/d/:id.html",
    component: _344372e0,
    name: "en_dshop_id"
  }, {
    path: "/zh-hant/p/:title/s/:spuPart/i/:sku.html",
    component: _6f7de986,
    name: "zh-hant_pdp_title_i_sku1"
  }, {
    path: "/en/p/:title/s/:spuPart/i/:sku.html",
    component: _6f7de986,
    name: "en_pdp_title_i_sku1"
  }, {
    path: "/zh-hant/p/:title/i/:sku.html",
    component: _6f7de986,
    name: "zh-hant_pdp_title_i_sku"
  }, {
    path: "/en/p/:title/i/:sku.html",
    component: _6f7de986,
    name: "en_pdp_title_i_sku"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
